export const SESSION_EXPIRED = "SESSION_EXPIRED";
export const SESSION_RESTORED = "SESSION_RESTORED";
